import * as React from 'react';
import {PureComponent} from 'react';
import {mapControlStyle} from "./mapControlStyle";

export default class LocationIcon extends PureComponent <any, any> {
    render() {
        return (
            <svg viewBox="-40 -15 120 100" style={{...mapControlStyle}}>
                <path className="cls-1" d="M73.1,30.83" transform="translate(-72.55 -50.17)"/>
                <path className="cls-1" d="M53.07,51.32" transform="translate(-72.55 -50.17)"/>
                <line className="cls-1" x1="0.95" y1="24.18" x2="16.48" y2="88.54"/>
                <path className="cls-2"
                      d="M73.55,74.55a27.76,27.76,0,0,1-.74-5.07A18.62,18.62,0,0,1,110,68a18,18,0,0,1-.6,5.4"
                      transform="translate(-72.55 -50.17)"/>
                <line className="cls-1" x1="36.88" y1="23.23" x2="16.45" y2="87.8"/>
                <circle className="cls-2" cx="91.44" cy="70.12" r="11.56"
                        transform="translate(-73.34 -49.12) rotate(-0.65)"/>
            </svg>
        );
    }
}